import React from 'react'
import CircularProgress from '@mui/material/CircularProgress';
import Logo from './Logo'

export const ETLoading = ()=>{
    return  <div className="flex items-center justify-center h-screen px-4">
          <div className="flex flex-col items-center text-center max-w-[400px] w-full">
            <Logo/>
            <CircularProgress sx={{marginTop:'2.5rem'}}/>
          </div>
        </div>
}

